import { useRef } from "react"
import { useVideoPlaybackTracking } from "../../hooks/useVideoPlaybackTracking"

const VideoPlayer = ({ video, uuid, source, trackingIds, enabled, title }) => {
  const iframeRef = useRef(null)

  useVideoPlaybackTracking({
    iframeRef,
    uuid,
    videoId: video.VideoId,
    source,
    trackingIds,
    enabled,
  })

  return (
    <iframe
      ref={iframeRef}
      allowFullScreen
      allow="autoplay; encrypted-media; picture-in-picture; fullscreen; clipboard-write;"
      className="w-full h-full"
      frameBorder="0"
      loading="lazy"
      referrerPolicy="origin"
      src={video.VideoLink}
      title={title}
    />
  )
}

export default VideoPlayer
